/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 * Modal Error component for common cases
 *
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.12.0
 */

import { FC, ReactNode } from 'react';

import { Button } from '../../../components/common';
import { ImgStatusError } from '../../../components/common/Block/Img';
import { IAttrStyled } from '../../../types/globalTypes';
import { ICorporateModal } from '../../internationalization/types/corporate';
import { IModalRenderProps } from '../types/modalTypes';
import Modal from './Modal';
import { ModalCenterStyled } from './styled/ModalCenterStyled';

interface IModalError extends Pick<IModalRenderProps, 'onCloseModal'>, Pick<IAttrStyled, 'dataName'> {
    children?: ReactNode;
    title?: string;
    translation: ICorporateModal;
}

const ModalErrorCommon: FC<IModalError> = (props) => {
    const { children, dataName, title, translation, onCloseModal } = props;

    return (
        <Modal dataName={dataName || 'modal-error'} width="580px">
            <ModalCenterStyled>
                <ImgStatusError />
                <Modal.Title>{title || translation.errorMsg.defaultMessage}</Modal.Title>
                <Modal.Body style={{ maxHeight: 400 }}>{children}</Modal.Body>
                <Modal.Control>
                    <Button kind="medium" onClick={onCloseModal}>
                        {translation.accessibly}
                    </Button>
                </Modal.Control>
            </ModalCenterStyled>
        </Modal>
    );
};

export default ModalErrorCommon;
